export const PREFERENCE_KEY_BRAND_COLOR = "BRAND_COLOR";
export const PREFERENCE_KEY_BRAND_LOGO = "BRAND_LOGO";
export const PREFERENCE_KEY_GENERATE_INDEXATION_LETTER =
  "GENERATE_INDEXATION_LETTER";

// Prevent DDoSing ourselves
export const FORCED_DELAY /* In milliseconds */ = 1_000;
